import pxToRem from "../../functions/pxToRem";

export default function menu({ typography, colors, borders }) {
  const { size } = typography;
  const { text, background, grey } = colors;
  const { borderRadius } = borders;

  const menu = {
    defaultProps: {
      disableAutoFocusItem: true,
    },

    styleOverrides: {
      paper: {
        minWidth: pxToRem(180),
        boxShadow: `0 10px 40px -10px rgba(0, 0, 0, 0.2), 0 0 0 1px ${grey[200]}`,
        padding: `${pxToRem(8)} ${pxToRem(6)}`,
        fontSize: size.sm,
        color: text.main,
        textAlign: "left",
        backgroundColor: `${background.paper} !important`,
        borderRadius: borderRadius.lg,
        marginTop: pxToRem(4),
        maxHeight: pxToRem(300),
        overflowY: "auto",
        // The scrollbar is the app-wide slim one (base/globals.js).
      },

      list: {
        padding: 0,
      },
    },
  };

  return menu;
}
